import { defineNuxtPlugin, type NuxtApp } from '#app';
import { createRegistry } from '@devhacker/shared/plugins/registry/createRegistry';
import type { User } from '@devhacker/shared/features/user/types/user';
import { useUserStore } from '~/features/user/store';
import { errorHandler } from '~/utils/errorHandlerAuth';
import { requestInterceptors } from '~/utils/interceptorsRequestAuth';
import { useUserService } from '~/features/user/service';

export default defineNuxtPlugin((nuxtApp) => {
  const log = (nuxtApp as NuxtApp).$logger.withScope('®️ registry');
  const userStore = useUserStore();
  const userService = useUserService();

  const isAuthenticatedInWordpress = computed(() => userStore.isLoggedInWp || false);

  const registry = {
    interceptors: {
      authRequest: requestInterceptors,
      authError: errorHandler,
    },
    auth: {
      isAuthenticatedInWordpress,
      changeAfterLoginAction,
      setRefreshTokenPending: (isPending: boolean) => userStore.setUserRT(isPending),
    },
    user: {
      updateUser: userService.setUser,
      patchUser: userService.patchUser,
    },
  };

  function changeAfterLoginAction(action?: (user: User | null) => void) {
    userStore.afterLoginAction = action ? () => action(userStore.userData) : undefined;
  }

  log('create registry', registry);
  nuxtApp.provide('registry', createRegistry(registry));
});
